<template lang="pug">
.introContainer
    .introImg(:style="{'background-image': 'url(' + intro[year].src + ')'}")
        .introMask
            .introText {{intro[year].text1}}
            h1.TitleU {{intro[year].name}}
            .introText(v-html="intro[year].text2")
    
</template>

<script>

export default {
    props: ['year'],
    data () {
        return {
            intro: {
                2023: {
                    name: "The Third Workshop on Multiple Input Modalities and Sensations for VR/AR Interactions (MIMSVAI 2023)",
                    src: 'https://mimsvai.github.io/static/imgs/banner.jpg',//image less than 5
                    text1: 'October 9th, 2023, in Cancún, Mexico',
                    text2: '<span>Workshop in conjunction with </span><a href="https://www.ubicomp.org/ubicomp2023/" target="blank" style="color: #e89700;">UbiComp 2023↗︎</a>'
                },
                2022: {
                    name: "The Second Workshop on Multiple Input Modalities and Sensations for VR/AR Interactions (MIMSVAI 2022)",
                    src: 'https://mimsvai.github.io/static/imgs/banner.jpg',//image less than 5
                    text1: 'September 11, 2022, organised virtually',
                    text2: '<span>Workshop in conjunction with </span><a href="https://www.ubicomp.org/ubicomp2022/" target="blank" style="color: #e89700;">UbiComp 2022↗︎</a>'
                },
                2021: {
                    name: "The First Workshop on Multiple Input Modalities and Sensations for VR/AR Interactions (MIMSVAI 2021)",
                    src: 'https://mimsvai.github.io/static/imgs/banner.jpg',//image less than 5
                    text1: 'September 26, 2021, organised virtually',
                    text2: '<span>Workshop in conjunction with </span><a href="https://www.ubicomp.org/ubicomp2021/" target="blank" style="color: #e89700;">UbiComp 2021↗︎</a>'
                }
            }
        }
    },
    methods: {

    }
}
</script>

<style lang="sass" scoped>
.introContainer
    max-width: 1080px
    margin: auto
.introImg
    max-width: 1280px
    margin: auto
    height: 720px
    border-radius: 8px
    position: relative
    // /*opacity: 0.7; optional will put a slide fade on the background images  */
    background-attachment: fixed
    background-position: right
    background-repeat: no-repeat
    background-color: #FFF
    background-size: cover
.introText
    font-size: 19px
.introMask
    position: inherit
    padding: 20px
    background-color: #ffffffba
    top: 400px
    z-index: 1

@media all and (max-width: 960px)
    .TitleU
        font-size: 25px
    .introMask
        top: 200px

</style>



// WEBPACK FOOTER //
// src/components/mainPage/Intro.vue